/* 语言切换组件样式 */
.language-switch {
  position: fixed;
  top: 15px;
  right: 175px;
  z-index: 10000;
}

/* 在封面页的动画效果 */
.hero-cover ~ * .language-switch,
.landing-page .language-switch {
  animation: languageFadeIn 1.5s ease-out 2s backwards;
}

@keyframes languageFadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 语言按钮 */
.language-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  background: rgba(30, 35, 60, 0.8);
  border: 1px solid rgba(0, 170, 255, 0.3);
  border-radius: 25px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  backdrop-filter: blur(10px);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  outline: none;
}

.language-button:hover {
  background: rgba(30, 35, 60, 0.95);
  border-color: rgba(0, 170, 255, 0.6);
  box-shadow: 0 6px 20px rgba(0, 170, 255, 0.3);
  transform: translateY(-2px);
}

.language-button:active {
  transform: translateY(0);
}

.language-icon {
  display: flex;
  align-items: center;
  font-size: 18px;
  color: #00aaff;
  transition: transform 0.3s ease;
}

.language-button:hover .language-icon {
  transform: rotate(180deg);
}

.language-text {
  letter-spacing: 0.5px;
  text-transform: uppercase;
  font-size: 13px;
}

/* 语言菜单 */
.language-menu {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  background: rgba(30, 35, 60, 0.95);
  border: 1px solid rgba(0, 170, 255, 0.3);
  border-radius: 15px;
  overflow: hidden;
  backdrop-filter: blur(15px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
  min-width: 140px;
  animation: menuSlideDown 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 10001;
}

@keyframes menuSlideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 语言选项 */
.language-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  transition: all 0.2s ease;
  position: relative;
}

.language-option:not(:last-child) {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.language-option:hover {
  background: rgba(0, 170, 255, 0.1);
  color: #ffffff;
}

.language-option.active {
  background: rgba(0, 170, 255, 0.15);
  color: #00aaff;
  font-weight: 600;
}

.option-flag {
  font-size: 18px;
  line-height: 1;
}

.option-text {
  flex: 1;
  letter-spacing: 0.3px;
}

.language-option i {
  font-size: 16px;
  color: #00aaff;
  margin-left: auto;
}

/* 遮罩层 */
.language-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: transparent;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .language-switch {
    top: 20px;
    right: 20px;
  }

  .language-button {
    padding: 8px 14px;
    font-size: 12px;
  }

  .language-icon {
    font-size: 16px;
  }

  .language-text {
    font-size: 12px;
  }

  .language-menu {
    min-width: 120px;
  }

  .language-option {
    padding: 10px 14px;
    font-size: 13px;
  }

  .option-flag {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .language-switch {
    top: 15px;
    right: 15px;
  }

  .language-button {
    padding: 7px 12px;
    gap: 6px;
  }

  .language-icon {
    font-size: 15px;
  }

  .language-text {
    font-size: 11px;
  }

  .language-menu {
    min-width: 110px;
  }

  .language-option {
    padding: 9px 12px;
    font-size: 12px;
    gap: 8px;
  }

  .option-flag {
    font-size: 15px;
  }

  .language-option i {
    font-size: 14px;
  }
}

/* Login-page light variant */
.access-gate .language-switch { top: 20px !important; right: 24px !important; }
.access-gate .language-button {
  min-height: 42px !important; padding: 0 15px !important; gap: 7px !important;
  color: #4f5965 !important; background: rgba(255, 255, 255, 0.9) !important;
  border: 1px solid #dce3ec !important; border-radius: 21px !important;
  box-shadow: 0 4px 16px rgba(37, 55, 84, 0.07) !important;
  backdrop-filter: blur(16px) saturate(150%) !important;
}
.access-gate .language-button:hover {
  color: var(--hm-blue) !important; background: #fff !important;
  border-color: #aac6ec !important; box-shadow: 0 8px 22px rgba(37, 55, 84, 0.11) !important;
  transform: translateY(-1px) !important;
}
.access-gate .language-button:active { transform: translateY(0) !important; }
.access-gate .language-icon { color: var(--hm-blue) !important; font-size: 18px !important; }
.access-gate .language-button:hover .language-icon { transform: rotate(16deg) !important; }
.access-gate .language-text {
  color: inherit !important; font-size: 12px !important;
  font-weight: 650 !important; letter-spacing: 0.045em !important;
}
.access-gate .language-menu {
  top: calc(100% + 8px) !important; min-width: 150px !important; padding: 6px !important;
  color: var(--hm-ink) !important; background: rgba(255, 255, 255, 0.98) !important;
  border: 1px solid #dce3ec !important; border-radius: 14px !important;
  box-shadow: 0 18px 42px rgba(37, 55, 84, 0.14) !important;
  backdrop-filter: blur(20px) saturate(150%) !important;
}
.access-gate .language-option {
  min-height: 42px !important; padding: 9px 11px !important;
  color: #4f5965 !important; border: 0 !important; border-radius: 9px !important;
}
.access-gate .language-option:not(:last-child) { border-bottom: 0 !important; }
.access-gate .language-option:hover { color: var(--hm-blue) !important; background: #f2f7ff !important; }
.access-gate .language-option.active {
  color: var(--hm-blue) !important; background: #eaf2ff !important; font-weight: 650 !important;
}
.access-gate .language-option i { color: var(--hm-blue) !important; }
.access-gate .option-flag {
  display: grid !important; place-items: center !important;
  width: 26px !important; height: 26px !important;
  background: #fff !important; border: 1px solid #e3e8ef !important;
  border-radius: 8px !important; font-size: 15px !important;
}

@media (max-width: 600px) {
  .access-gate .language-switch { top: 12px !important; right: 12px !important; }
  .access-gate .language-button {
    min-width: 40px !important; min-height: 40px !important;
    justify-content: center !important; padding: 0 11px !important;
  }
  .access-gate .language-text { display: none !important; }
}

